import bristolText from "./text/bristol"
import cambridgeText from "./text/cambridge"
import colchesterText from "./text/colchester"
import coventryText from "./text/coventry"
import eastbourneText from "./text/eastbourne"
import leicesterText from "./text/leicester"
import londonText from "./text/london"
import manchesterText from "./text/manchester"
import northamptonText from "./text/northampton"
import nottinghamText from "./text/nottingham"
import sheffieldText from "./text/sheffield"

// All of the text objects imported above have the same shape of:
// {
//   summary: Node,
//   location: Node,
//   atHomeFeeling: Node,
//   withGardens: Node,
//   petFriendly: Node,
//   activities: Node,
// }

export default {
  districts: {
    colchester: colchesterText,
  },
  cities: {
    bristol: bristolText,
    cambridge: cambridgeText,
    coventry: coventryText,
    eastbourne: eastbourneText,
    leicester: leicesterText,
    london: londonText,
    manchester: manchesterText,
    northampton: northamptonText,
    nottingham: nottinghamText,
    sheffield: sheffieldText,
  },
}
